/**
 * @param {object} player - Player details.
 * @param {object[]} columns - Column data.
 * @param {'totals'|'averages'|'benchmarkedTotals'|'benchmarkedAverages'} dataType - Data type.
 * @returns {object[]} Row data for the given player.
 */
export const composeRowDataForPlayer = ( player, columns, dataType ) => {
    const getValue = ( { accessor } ) => {
        const val = player.stats[ dataType ][ accessor ];
        
        // We need to pick the value off the object for benchmarking data but
        // not for standard.
        return val?.value ?? val;
    };

    return {
        rank: -1,
        player: player.details,
        position: player.details.position,
        team: player.team.teamId,
        ...columns.reduce( ( prev, curr ) => ( {
            ...prev,
            [ curr.accessor ]: getValue( curr )
        } ), {} )
    };
};

